import { useMemo } from "react";
import { MapPin } from "lucide-react";
import { useCartStore, type ShippingAddress } from "../store/cartStore";
import {
  getCountryOptions,
  STATE_REQUIRED_COUNTRIES,
  STATES,
} from "../data/shippingCountries";

const selectCls =
  "w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-900";

export function ShippingSelector() {
  const address = useCartStore((s) => s.address);
  const setAddress = useCartStore((s) => s.setAddress);

  const countries = useMemo(() => getCountryOptions(), []);
  const country = address?.country ?? "";
  const state = address?.state ?? "";
  const needsState = STATE_REQUIRED_COUNTRIES.has(country as any);
  const states = needsState ? STATES[country] ?? [] : [];

  const handleCountry = (code: string) => {
    if (!code) {
      setAddress(null);
      return;
    }
    setAddress({
      country: code,
      state: "",
      fullName: "",
      address: "",
      city: "",
      zip: "",
    } as ShippingAddress);
  };

  const handleState = (code: string) => {
    if (!address) return;
    setAddress({ ...address, state: code });
  };

  return (
    <div className="space-y-2">
      <label className="flex items-center gap-1.5 text-xs font-semibold text-slate-500">
        <MapPin className="h-3.5 w-3.5" />
        Ship to
      </label>
      <select
        value={country}
        onChange={(e) => handleCountry(e.target.value)}
        className={selectCls}
      >
        <option value="">Select country</option>
        {countries.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </select>

      {needsState && (
        <select
          value={state}
          onChange={(e) => handleState(e.target.value)}
          className={selectCls}
        >
          <option value="">Select state / province</option>
          {states.map((s) => (
            <option key={s.code} value={s.code}>
              {s.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
